import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import MFDDashboard from './pages/MFDDashboard';
import MFDCategoryReport from './pages/MFDCategoryReport';
import MFDPortfolioAudit from './pages/MFDPortfolioAudit';
import RetailDashboard from './pages/RetailDashboard';
import MFDChangePassword from './pages/MFDChangePassword';
import MFDForgotPassword from './pages/MFDForgotPassword';

const PrivateRoute = ({ children, role, allowForced }) => {
  const { token, user } = useAuth();
  if (!token) return <Navigate to="/login" />;
  if (role && user?.user_type !== role) return <Navigate to="/login" />;
  if (role === 'mfd' && user?.must_change_password && !allowForced) return <Navigate to="/mfd/change-password" />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/mfd/forgot-password" element={<MFDForgotPassword />} />
          <Route path="/admin" element={
            <PrivateRoute role="admin"><AdminDashboard /></PrivateRoute>
          } />
          <Route path="/mfd" element={
            <PrivateRoute role="mfd"><MFDDashboard /></PrivateRoute>
          } />
          <Route path="/mfd/change-password" element={
            <PrivateRoute role="mfd" allowForced><MFDChangePassword /></PrivateRoute>
          } />
          <Route path="/mfd/category-report" element={
            <PrivateRoute role="mfd"><MFDCategoryReport /></PrivateRoute>
          } />
          <Route path="/mfd/portfolio-audit" element={
            <PrivateRoute role="mfd"><MFDPortfolioAudit /></PrivateRoute>
          } />
          <Route path="/retail" element={
            <PrivateRoute role="retail"><RetailDashboard /></PrivateRoute>
          } />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
